(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-actions"] && !Shopify.designMode) return;
  try {
    /* Reseller Account Panel — populates data and handles sign-out.
     Visibility is driven by [data-reseller-mode] on <html> via CSS. */
  class ResellerAccountPanel extends HTMLElement {
    connectedCallback() {
      if (localStorage.getItem('cactus_reseller_active') !== 'true') return;
      requestAnimationFrame(() => this._init());
    }

    _init() {
      /* Populate reseller info from session */
      try {
        const session = JSON.parse(localStorage.getItem('cactus_reseller_session') || '{}');
        const emailEl = this.querySelector('[data-reseller-email]');
        const codeEl = this.querySelector('[data-reseller-code]');
        if (emailEl && session.email) emailEl.textContent = session.email;
        if (codeEl && session.discountCode) codeEl.textContent = session.discountCode;
      } catch {}

      /* The collection selector is bound by applyResellerUI in
         layout/theme.liquid, which re-runs after every header re-render. */

      const btn = this.querySelector('[data-reseller-signout]');
      if (btn) {
        /* This used to remove three localStorage keys and reload. The UI
           said "signed out"; the Firebase refresh token was untouched in
           IndexedDB, so re-setting `cactus_reseller_active` in devtools
           restored full reseller mode and cactus-reseller-checkout.js
           would happily mint a fresh ID token and submit orders. It could
           not call signOut() itself — this block is bundled as a classic
           script and cannot ESM-import Firebase — so the real routine
           lives in the inline module at the top of this snippet, which
           imports the SDK on demand and deletes the persisted credential
           either way. */
        btn.addEventListener('click', () => {
          const api = window.CactusResellerSession;
          if (!api) {
            /* Cannot happen: the inline script at the top of this snippet
               runs before this deferred bundle. Loud rather than silently
               pretending to sign out. */
            console.error('[Cactus Reseller] CactusResellerSession missing; sign-out aborted');
            return;
          }
          /* On success `signOut()` reloads, so nothing after it runs. It now
             REJECTS when the credential purge failed (IndexedDB blocked or
             timed out) instead of reloading into a page that claims the
             reseller is signed out — so re-enable the button and say so,
             rather than leaving a dead control and a false impression. */
          const original = btn.textContent;
          btn.disabled = true;
          api.signOut().catch(() => {
            btn.disabled = false;
            btn.textContent = original;
            /* Localized by Liquid onto the button itself — this block is a
               static asset, so `| t` cannot run here. The literal is only a
               last resort for a stale cached copy of the markup. */
            btn.setAttribute(
              'title',
              btn.dataset.signoutIncompleteTitle ||
                'Sign-out incomplete — close other tabs of this shop and try again'
            );
          });
        });
      }
    }
  }
  if (!customElements.get('reseller-account-panel')) {
    customElements.define('reseller-account-panel', ResellerAccountPanel);
  }

  /* Announcement Bar Toggle.
     There are two instances on the page (desktop popover + mobile dialog) and
     the markup is rendered lazily / can be morph-re-rendered, which is why the
     old per-element custom element raced and showed the wrong state on reload.
     This version owns no per-element state: it delegates the change event and
     re-syncs every checkbox from localStorage at each point the toggle can
     (re)appear (load, pageshow/bfcache, drawer open, cross-tab storage). */
  const STORAGE_KEY = 'reseller_hide_announcements';

  function cactusAnnouncementsHidden() {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }

  function cactusSyncAnnouncementToggles() {
    const hidden = cactusAnnouncementsHidden();
    document.documentElement.toggleAttribute('data-hide-announcements', hidden);
    document
      .querySelectorAll('reseller-announcement-toggle input[type="checkbox"]')
      .forEach((cb) => {
        cb.checked = hidden;
      });
  }

  /* Persist + sync on any toggle change (delegated, so it survives re-renders). */
  document.addEventListener('change', (event) => {
    const cb = event.target;
    if (!cb || !cb.matches || !cb.matches('reseller-announcement-toggle input[type="checkbox"]')) {
      return;
    }
    localStorage.setItem(STORAGE_KEY, cb.checked ? 'true' : 'false');
    cactusSyncAnnouncementToggles();
  });

  /* Keep every instance — and other tabs — in agreement. */
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) cactusSyncAnnouncementToggles();
  });

  /* Re-apply wherever the toggle can (re)appear or be restored. */
  window.addEventListener('pageshow', cactusSyncAnnouncementToggles);
  document.addEventListener('DOMContentLoaded', cactusSyncAnnouncementToggles);
  /* The account drawer/popover renders its toggle lazily on open. */
  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest &&
        event.target.closest('.account-drawer, #account-popover, account-button, [popover]')
      ) {
        requestAnimationFrame(cactusSyncAnnouncementToggles);
      }
    },
    true
  );

  /* Early apply: this bundle is deferred, so the DOM is already parsed. */
  cactusSyncAnnouncementToggles();
  if (localStorage.getItem('cactus_reseller_active') === 'true') {
    document.documentElement.setAttribute('data-reseller-mode', '');
  }
  } catch(e) { console.error(e); }
})();

})();
